<template>
    <b-card no-body>
        <b-card-body>
            <b-card bg-variant="light">
                <b-form-row @keyup.enter="load" class="ml-2">
                    <b-col sm="4">
                        <lg-finder-page-pessoa id="finderPessoaBaixaList" label="Responsável:"
                            :prefix="prefix + title + ' > '" title="Responsáveis" v-model="form.pessoa"
                            invalidFeedback="Informe um responsável!" @onselect="handlePessoaSelect" />
                    </b-col>
                    <b-col sm="2">
                        <lg-form-date description='' v-model="form.dataDe" label="De:" invalidFeedback=" " />
                    </b-col>
                    <b-col sm="2">
                        <lg-form-date description='' v-model="form.dataAte" label="Até:" invalidFeedback=" " />
                    </b-col>
                    <b-col sm="4">
                        <lg-form-select v-model="form.status" :loadFunction="statusList" labelFormGroupBind="Status:"
                            label="descricao" description=" " filterList="true" @input="load" style="z-index: 1000;" />
                    </b-col>
                </b-form-row>

                <b-form-row>
                    <!-- LINHA 2: Tombamento e Até -->
                    <b-col sm="2">
                        <lg-form-input v-model="form.tombamento" label="Tombamento:" invalidFeedback=" " />
                    </b-col>
                    <b-col sm="2">
                        <lg-form-input v-model="form.ateTombamento" label="Até:" invalidFeedback=" " />
                    </b-col>

                    <b-col sm="4">
                        <lg-form-input v-model="form.tombamentoSamp" label="Tombamento SAMP:" invalidFeedback=" " />
                    </b-col>
                    <b-col sm="4">
                        <lg-form-input v-model="form.descricao" label="Descrição:" invalidFeedback=" " />
                    </b-col>
                </b-form-row>

                <b-form-row>
                    <!-- LINHA 4: Botões alinhados à direita -->
                    <b-col sm="12" class="d-flex justify-content-end align-items-center mt-3">
                        <b-button id="limpar" class="mr-2" size="sm" pill variant="primary" @click="clearForm()">
                            <div class="btn-size-alinhamento">
                                <b-icon icon="eraser" />
                            </div>
                            <b-tooltip target="limpar" title="Limpar"></b-tooltip>
                        </b-button>
                        <b-button id="localizar" class="mr-2" size="sm" pill variant="primary" @click="load()">
                            <div class="btn-size-alinhamento">
                                <b-icon icon="search" />
                            </div>
                            <b-tooltip target="localizar" title="Localizar"></b-tooltip>
                        </b-button>
                        <b-button v-if="temPrivilegioInclusao()" id="novo" class="mr-2" size="sm" pill
                            variant="secondary" @click="mostrarModal()">
                            <div class="btn-size-alinhamento">
                                <b-icon scale="1" icon="plus" />
                            </div>
                            <b-tooltip target="novo" title="Adicionar novo..."></b-tooltip>
                        </b-button>
                    </b-col>
                </b-form-row>


                <b-table responsive class="mt-2" small :busy="busy" :items="records" :fields="tableFields" :hover="true"
                    show-empty @row-dblclicked="clickRow">
                    <template #empty>
                        <p>Nenhum registro encontrado</p>
                    </template>
                    <template #table-busy>
                        <div class="text-center text-primary my-2">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                    </template>
                    <template #cell(data)="row">
                        {{ formatDate(row.item.data) }}
                    </template>
                    <template #cell(editar)="row">
                        <b-button v-if="row.item.codstatus == 225 && temPrivilegioEdicao()" :id="'edit-' + row.index"
                            variant="primary" size="sm" pill @click="editar(row.item)">
                            <b-icon icon="pencil-square" />
                            <b-tooltip :target="'edit-' + row.index" title="Editar..."></b-tooltip>
                        </b-button>
                    </template>
                    <template #cell(finalizar)="row">
                        <b-button v-if="(row.item.codstatus == 225) && temPrivilegioEdicao()"
                            :id="'finalizar-' + row.index" variant="primary" size="sm" pill
                            @click="finalizar(row.item)">
                            <b-icon icon="check2-circle" />
                            <b-tooltip :target="'finalizar-' + row.index" title="Finalizar..."></b-tooltip>
                        </b-button>
                    </template>
                    <template v-slot:cell(visualizar)="row">
                        <b-button
                            v-if="row.item.codstatus == 142 || row.item.codstatus == 149 || row.item.codstatus == 143 || row.item.codstatus == 144"
                            :id="row.index + 'visualizar-button'" class="my-2" size="sm" pill variant="primary"
                            @click="visualizar(row.item)">
                            <b-icon icon="file-earmark-text" />
                            <b-tooltip :target="row.index + 'visualizar-button'" title="Visualizar..."></b-tooltip>
                        </b-button>
                    </template>
                    <template v-slot:cell(estornar)="row">
                        <b-button
                            v-if="(row.item.codstatus == 142 || row.item.codstatus == 149) && temPrivilegioEstornar()"
                            :id="row.index + 'estornar-button'" class="my-2" size="sm" pill variant="primary"
                            @click="estornar(row.item)">
                            <b-icon icon="arrow-left" />
                            <b-tooltip :target="row.index + 'estornar-button'" title="Estornar..."></b-tooltip>
                        </b-button>
                    </template>
                    <template #cell(relatorioPdf)="row">
                        <div :id="'relatorioPdf-' + row.item.id"
                            v-if="(row.item.codstatus == 142 || row.item.codstatus == 149)">
                            <img @click="gerarPdf(row.item)" :src="pdf" class="img img--clickable" alt="PDF" />
                            <b-tooltip :target="'relatorioPdf-' + row.item.id" title="Relatórios"></b-tooltip>

                        </div>
                    </template>
                    <template #cell(relatorioXlsx)="row">
                        <div :id="'relatorioXlsx-' + row.item.id"
                            v-if="row.item.codstatus === 142 || row.item.codstatus === 149">
                            <img @click="gerarXlsx(row.item)" :src="xlsIcon" class="img img--clickable" alt="XLSX" />
                            <b-tooltip :target="'relatorioXlsx-' + row.item.id" title="Relatórios" />
                        </div>
                    </template>
                </b-table>
                <b-row class="mt-2" v-if="records && records.length">
                    <b-col cols="6" class="d-flex align-items-center" style="font-size: 12px">
                        Página {{ page }} de {{ totalPage }} - {{ total }} registros
                        <b-form-select size="sm" v-model="perPage" @change="load()" :options="perPageOptions"
                            class="ml-3"></b-form-select>
                    </b-col>
                    <b-col cols="6">
                        <div class="d-flex justify-content-end align-items-end">
                            <b-pagination v-model="page" :per-page="perPage" :total-rows="total"
                                style="margin-top: 10px; margin-bottom: 10px"></b-pagination>
                        </div>
                    </b-col>
                </b-row>
            </b-card>
        </b-card-body>
        <BaixaItemBemPermanenteForm v-if="showModal" :prefix="prefix + title + ' > '" :id="id"
            :isVisualizar="isVisualizar" @close="fecharModal" />
        <BaixaItemBemPermanenteEstornoForm v-if="showModalEstorno" :prefix="prefix + title + ' > '" :id="id"
            @close="fecharModalEstorno" />
    </b-card>
</template>

<script>
import LgFinderPagePessoa from "@/components/Finders/LgFinderPagePessoa.vue";
import LgFormDate from "@/core/components/Form/LgFormDate.vue";
import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import { ListResourceMixin } from "@/core/mixins/resource";
import ConfirmMixin from "@/core/mixins/confirm";
import verificaPrivilegio from "@/utils/VerificaPrivilegio";
import PrivilegiosEnum from "@/core/utils/PrivilegioEnum";
import LgFormSelect from "@/core/components/Form/LgFormSelect.vue";
import ResourceService from "@/core/api/ResourceService";
import BaixaItemBemPermanenteForm from "@/modules/patrimonio/baixa-item-bem-permanente/BaixaItemBemPermanenteForm.vue";
import BaixaItemBemPermanenteEstornoForm
    from "@/modules/patrimonio/baixa-item-bem-permanente/BaixaItemBemPermanenteEstornoForm.vue";
import moment from "moment";
import DownloadArquivoService from "@/core/utils/DownloadArquivoUtil";
import PdfIcon from "@/core/assets/icons/pdf.png";
import xlsIcon from "@/core/assets/icons/xls.png";

export default {
    components: {
        BaixaItemBemPermanenteEstornoForm,
        BaixaItemBemPermanenteForm,
        LgFormSelect,
        LgFinderPagePessoa,
        LgFormDate,
        LgFormInput,
    },
    props: {
        prefix: {
            type: String,
            default: "",
        },
    },
    mixins: [ListResourceMixin, ConfirmMixin],
    data() {
        return {
            title: "Baixa Item Bem Permanente",
            id: null,
            showModal: false,
            isVisualizar: false,
            showModalEstorno: false,
            page: 1,
            perPage: 10,
            perPageOptions: [10, 25, 50, 100],
            busy: false,
            records: [],
            total: 0,
            totalPage: 0,
            form: {
                pessoa: {},
                dataDe: "",
                dataAte: "",
                status: undefined,
                tombamento: "",
                ateTombamento: "",
                tombamentoSamp: "",
                descricao: "",
            },
            pdf: PdfIcon,
            xlsIcon: xlsIcon
        };
    },
    beforeMount() {
        this.$statusService = new ResourceService(`/api/status/tipo/40`);
        this.$service = new ResourceService(`/api/baixaitembempermanente`)
        this.load()
    },
    watch: {
        page() {
            this.load();
        },
    },
    computed: {
        tableFields() {
            return [
                { key: "data", label: "Data" },
                { key: "responsavel", label: "Responsável" },
                { key: "statusDescricao", label: "Status" },
                { key: "editar", label: "", tdClass: "w-1" },
                { key: "finalizar", label: "", tdClass: "w-1" },
                { key: "visualizar", label: "", tdClass: "w-1" },
                { key: "estornar", label: "", tdClass: "w-1" },
                { key: "relatorioPdf", label: " ", tdClass: "w-1", thClass: "text-center" },
                { key: "relatorioXlsx", label: " ", tdClass: "w-1", thClass: "text-center" }
            ];
        },
    },
    methods: {
        async gerarPdf(item) {
            this.busy = true;
            var { data } = await new ResourceService(`/api/relatorio/gerar-relatorio-baixa-item-bem-permanente`).get(`PDF/${item.cod}`);
            DownloadArquivoService(data.arquivoBase64, data.nomeArquivo);
            this.busy = false;
        },
        async gerarXlsx(item) {
            this.busy = true;
            var { data } = await new ResourceService(
                `/api/relatorio/gerar-relatorio-baixa-item-bem-permanente`
            ).get(`EXCEL/${item.cod}`)
            DownloadArquivoService(data.arquivoBase64, data.nomeArquivo)
            this.busy = false;
        },
        temPrivilegioEdicao() {
            return verificaPrivilegio(PrivilegiosEnum.BAIXA_BEM_PERMANENTE_EDITAR);
        },
        temPrivilegioInclusao() {
            return verificaPrivilegio(PrivilegiosEnum.BAIXA_BEM_PERMANENTE_INCLUIR);
        },
        temPrivilegioRelatorio() {
            return verificaPrivilegio(PrivilegiosEnum.RELATORIO_GERAR_BAIXA_ITEM_BEM_PERMANENTE);
        },
        temPrivilegioEstornar() {
            return verificaPrivilegio(PrivilegiosEnum.BAIXA_BEM_PERMANENTE_ESTORNAR)
        },
        handlePessoaSelect(item) {
            this.form.pessoa = item;
            this.load();
        },
        async load() {
            this.busy = true;
            const filtro = {};
            if (this.form.pessoa && this.form.pessoa.id) {
                filtro.codPessoa = this.form.pessoa.id;
            }
            if (this.form.dataDe) {
                filtro.dtInicio = moment(this.form.dataDe).format('YYYY-MM-DD[T]HH:mm:ss');
            }
            if (this.form.dataAte) {
                filtro.dtFim = moment(this.form.dataAte).format('YYYY-MM-DD[T]HH:mm:ss');
            }
            if (this.form.status !== undefined) {
                filtro.statusParam = this.form.status.id;
            }
            if (this.form.tombamento) {
                filtro.numTombInicio = this.form.tombamento;
            }
            if (this.form.ateTombamento) {
                filtro.numTombFim = this.form.ateTombamento;
            }
            if (this.form.tombamentoSamp) {
                filtro.numTombSamp = this.form.tombamentoSamp;
            }
            if (this.form.descricao) {
                filtro.descricao = this.form.descricao;
            }
            await this.$loadResource({
                size: this.perPage,
                page: this.page,
                params: filtro,
            });
            this.busy = false;

        },
        clearForm() {
            this.form = {
                pessoa: {},
                dataDe: "",
                dataAte: "",
                status: undefined,
                tombamento: "",
                ateTombamento: "",
                tombamentoSamp: "",
                descricao: "",
            };
            this.load();
        },
        finalizar(item) {
            this.$confirm("Finalizar item?")
                .then(async (response) => {
                    if (response) {
                        try {
                            this.busy = true;
                            await this.$service.post("finalizar/" + item.cod);
                            this.$notify({
                                type: "success",
                                message: "Baixa Item Permanente finalizado com sucesso!",
                            });
                            this.load();
                        } catch (error) {
                            this.busy = false;
                            this.$notify({
                                type: "danger",
                                message: error.response.data,
                            });
                        }
                    }
                })
                .catch(() => { });
        },
        estornar(item) {
            this.id = item.cod;
            this.showModalEstorno = true;
        },
        fecharModalEstorno() {
            this.showModalEstorno = false;
            this.id = null;
            this.load();
        },
        cancelarModalEstorno() {
            this.id = null;
            this.showModalEstorno = false;
            this.load();
        },
        async statusList() {
            return this.$statusService.find();
        },
        cancelar() {
            this.id = null;
            this.isVisualizar = false;
            this.showModal = false;
            this.load();
        },
        mostrarModal() {
            this.id = null;
            this.isVisualizar = false;
            this.showModal = true;
        },
        fecharModal() {
            this.showModal = false;
            this.isVisualizar = false;
            this.id = null;
            this.load();
        },
        editar(item) {
            this.id = item.cod;
            this.isVisualizar = false;
            this.showModal = true;
        },
        visualizar(item) {
            this.id = item.cod;
            this.isVisualizar = true;
            this.showModal = true;
        },
        clickRow(item) {
            this.$emit("row-clicked", item);
        },
        formatDate(date) {
            return date ? new Date(date).toLocaleDateString() : "";
        },
    },
};
</script>
